import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  Output,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';

@Directive({
  selector: 'input [dfInputDebounce]',
})
export class DfInputDebounceDirective implements OnDestroy {
  @Output() inputValueChange = new EventEmitter<string>();
  private eventSubscription: Subscription = Subscription.EMPTY;

  constructor(private hostElement: ElementRef) {}

  ngOnDestroy(): void {
    this.eventSubscription.unsubscribe();
  }

  @HostListener('input')
  handleInputEvent(): void {
    this.eventSubscription = fromEvent(this.hostElement.nativeElement, 'input')
      .pipe(
        map((event: KeyboardEvent) => {
          event.stopImmediatePropagation();
          return (event.target as HTMLInputElement).value;
        }),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((event: string) => {
        this.inputValueChange.emit(event);
      });
  }
}
